import * as React from "react";
import { createReactError } from "logic/errors/ReportedErrors";
import ErrorsActions from "actions/errors/ErrorsActions";
import TelemetryContext from "logic/telemetry/TelemetryContext";
class RuntimeErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    ErrorsActions.report(createReactError(error, { componentStack: info == null ? void 0 : info.componentStack }));
    this.context.sendErrorReport(error);
  }
  render() {
    const { children } = this.props;
    return children;
  }
}
RuntimeErrorBoundary.contextType = TelemetryContext;
export default RuntimeErrorBoundary;
